<!-- enterprise 企业能源管理  -->
<template>
  <div class="OverviewAll" style=" padding: 0 !important;">
    <div class="kanban">
      <div class="tit" style="width: 100%;height: 65px;margin-bottom: 20px;">
        <img src="@/assets/enterprise/bt.png" style="width: 100%;height: 100%;" />
        <span class="txt">运行总览</span> 
        <div class="my-timer">
          {{ timerYMD }}
          <div class="xingqi">{{ timerWeek }}</div>
          {{ timerHMS }}
        </div>
        <div class="imgs">
          <img src="@/assets/enterprise/guan.png" v-if="fullscreen" @click="handleFullScreen" />
          <img src="@/assets/enterprise/kai.png" v-else @click="handleFullScreen" />
        </div>
      </div>

      <div class="con_tent">
        <!-- 第一行 -->
        <div class="one">
          <div class="box">
            <div class="o_txt">
              <div class="t1">昨日电量(kW·h)</div>
              <div class="t2">{{ oneData.a }}</div>
              <div class="t3">
                同期环比：
                <span v-show="a2 == 0">0% </span>
                <span class="span2" v-show="a2 < 0">{{ a2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="a2 > 0">{{ a2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
            <div class="o_txt">
              <div class="t1">本月电量(kW·h)</div>
              <div class="t2">{{ oneData.b }}</div>
              <div class="t3">
                同期环比：
                <span v-show="b2 == 0">0% </span>
                <span class="span2" v-show="b2 < 0">{{ b2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="b2 > 0">{{ b2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
            <div class="o_txt">
              <div class="t1">今年电量(kW·h)</div>
              <div class="t2">{{ oneData.c }}</div>
              <div class="t3">
                同期环比：
                <span v-show="c2 == 0">0% </span>
                <span class="span2" v-show="c2 < 0">{{ c2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="c2 > 0">{{ c2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="o_txt">
              <div class="t1">昨日电费(元)</div>
              <div class="t2 tt1">{{ oneData.d }}</div>
              <div class="t3">
                同期环比：
                <span v-show="d2 == 0">0% </span>
                <span class="span2" v-show="d2 < 0">{{ d2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="d2 > 0">{{ d2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
            <div class="o_txt">
              <div class="t1">本月电费(元)</div>
              <div class="t2 tt1">{{ oneData.e }}</div>
              <div class="t3">
                同期环比：
                <span v-show="e2 == 0">0% </span>
                <span class="span2" v-show="e2 < 0">{{ e2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="e2 > 0">{{ e2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
            <div class="o_txt">
              <div class="t1">今年电费(元)</div>
              <div class="t2 tt1">{{ oneData.f }}</div>
              <div class="t3">
                同期环比：
                <span v-show="f2 == 0">0% </span>
                <span class="span2" v-show="f2 < 0">{{ f2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="f2 > 0">{{ f2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="o_txt">
              <div class="t1">昨日碳排量(t)</div>
              <div class="t2 tt2">{{ oneData.g }}</div>
              <div class="t3">
                同期环比：
                <span v-show="g2 == 0">0% </span>
                <span class="span2" v-show="g2 < 0">{{ g2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="g2 > 0">{{ g2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
            <div class="o_txt">
              <div class="t1">本月碳排量(t)</div>
              <div class="t2 tt2">{{ oneData.h }}</div>
              <div class="t3">
                同期环比：
                <span v-show="h2 == 0">0% </span>
                <span class="span2" v-show="h2 < 0">{{ h2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="h2 > 0">{{ h2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
            <div class="o_txt">
              <div class="t1">今年碳排量(t)</div>
              <div class="t2 tt2">{{ oneData.i }}</div>
              <div class="t3">
                同期环比：
                <span v-show="i2 == 0">0% </span>
                <span class="span2" v-show="i2 < 0">{{ i2 | date_format }}%
                  <i class="el-icon-bottom"></i>
                </span>
                <span class="span3" v-show="i2 > 0">{{ i2 }}%
                  <i class="el-icon-top"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="hang">
          <div class="left">
            <div class="ttt">
              负荷曲线
            </div>
            <div class="cen" style="padding-top: 15px;">
              <div class="ul">
                <div class="li">
                  <img src="@/assets/enterprise/pei.png" alt="" />
                  配电房数量： <span class="li_txt">20 个</span>
                </div>
                <div class="li">
                  <img src="@/assets/enterprise/fuhe.png" alt="" />
                  负荷设备数：
                  <span class="li_txt">695 台</span>
                </div>
                <div class="li">
                  <img src="@/assets/enterprise/rong.png" alt="" />
                  负荷总容量：
                  <span class="li_txt">76469 kVA</span>
                </div>
                <div class="li">
                  <img src="@/assets/enterprise/ri.png" alt="" />
                  日最大需量：
                  <span class="li_txt">125268.6 kW</span>
                </div>
                <div class="li">
                  <img src="@/assets/enterprise/yue.png" alt="" />
                  月最大需量：
                  <span class="li_txt">34606.7 kW</span>
                </div>
              </div>
              <div class="canvasCircle">
                <div class="circle">
                  <div class="myprogress">
                    <canvasCircle color="#ffbb1d" name="负荷率" backgroundColor="#395667" :rate="64.28">
                    </canvasCircle>
                  </div>

                  <div class="circle_t">
                    <div class="num">2654.2</div>
                    <div class="name">实时负荷(kW)</div>
                  </div>
                </div>
                <div class="circle">
                  <div class="myprogress">
                    <canvasCircle color="#0084ff" name="负荷率" backgroundColor="#395667" :rate="84.26">
                    </canvasCircle>
                  </div>
                  <div class="circle_t">
                    <div class="num">6452.8</div>
                    <div class="name">日最大负荷(kW)</div>
                  </div>
                </div>
                <div class="circle">
                  <div class="myprogress">
                    <canvasCircle color="#f67229" name="负荷率" backgroundColor="#395667" :rate="65.36">
                    </canvasCircle>
                  </div>
                  <div class="circle_t">
                    <div class="num">68542.6</div>
                    <div class="name">月最大负荷(kW)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="ttt">
              负荷曲线
            </div>
            <div class="divbody" style="height: 200px; padding-top: 0">
              <vchart ref="vchartLine" style="height: 200px;"></vchart>
            </div>
          </div>
        </div>
        <div class="hang">
          <div class="left" style="position: relative;">
            <div class="ttt">
              尖峰平谷
            </div>
            <div class="tab-label">
              <div class="tab-label-span" @click="changSelectTab(0)" :style="tabStyle('0')">
                <span>当月</span>
              </div>
              <div class="tab-label-span" @click="changSelectTab(1)" :style="tabStyle('1')">
                <span>上月</span>
              </div>
            </div>
            <div class="cen">
              <div class="peakChart">
                <div class="peakPie" style="width: 320px;">
                  <vchart style="height: 200px;width: 320px;" ref="vchartPie"></vchart>
                </div>
                <div class="peakCloun" style="flex: 1;">
                  <vchart style="height: 200px;width: 100%;" ref="vchartBar"></vchart>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="ttt">
              本月碳排放趋势(t)
            </div>
            <div class="divbody" style="height: 200px; padding-top: 0">
              <vchart style="height: 200px;width: 100%;" ref="vchart"></vchart>
            </div>
          </div>
        </div>
        <div class="hang2">
          <div class="ttt ttt2">
            电能统计
          </div>
          <div class="cen"  >
            <vchart ref="vchart2"  style="width: 100%;height: 27vh;"></vchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vchart from "@/components/module/chart/vchart.vue";
import canvasCircle from "./canvasCircle.vue";
import request from "@/api/http.js";
import { getStatisticsPG } from "@/api/rateTemplate";
import { findDemand, getClassPGByMonthForHuaPu } from "@/api/abbNewApi";
// import { findLoadPowerByGroupNo } from "@/api/loadPower";
var pieOption = {};
export default {
  components: {
    vchart,
    canvasCircle,
  },
  data() {
    return {
      nowUnitInfo: {},
      title: DWSystemSetting.demoSystemInfo.enterprise,
      setId: 'd481f4ac59f44ba985881ca4249a35e8',
      oneData: {
        a: 18.58, //昨日电量
        a1: 20, //昨日电量 同比
        b: 265.59, //本月电量
        b1: 222, //本月电量 同比
        c: 1865.48, //今年电量
        c1: 1900, //今年电量 同比

        d: 26.00, //昨日电费
        d1: 30, //昨日电费 同比
        e: 289.00, //本月电费
        e1: 277, //本月电费 同比
        f: 2890.00, //今年电费
        f1: 2999, //今年电费 同比

        g: 16.49, //昨日碳排量
        g1: 19, //昨日碳排量 同比
        h: 295.86, //本月碳排量
        h1: 288, //本月碳排量 同比
        i: 1489.23, //今年碳排量
        i1: 1555, //今年碳排量 同比
      },
      co2TranslateRatio: 0.875, //折算系数
      barOption2: {
        "xAxis": [
          {
            "type": "category",
            "data": [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
              "29",
              "30",
              "31"
            ],
            "splitLine": {
              "show": false,
              "lineStyle": {
                "type": "dashed",
                "color": "#333333"
              }
            },
            "axisLabel": {
              "show": true,
              "textStyle": {
                "color": "#fff"
              }
            },
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": false
            }
          }
        ],
        "yAxis": [
          {
            "title": "能耗值（KWH）",
            "type": "value",
            "splitLine": {
              "lineStyle": {
                "type": "dashed",
                "color": "#333333"
              }
            },
            "axisLabel": {
              "show": true,
              "textStyle": {
                "color": "#ffff"
              }
            },
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": false
            }
          }
        ],
        "color": [
          "#0486ff",
          "#ffbb19"
        ],
        "legend": {
          "right": 30,
          "top": 5,
          "padding": [
            0,
            0,
            0,
            50
          ],
          "textStyle": {
            "color": "#fff"
          },
          "bottom": "5px"
        },
        "backgroundColor": "",
        "tooltip": {
          "trigger": "axis",
          "confine": true,
          "axisPointer": {
            "animation": false
          }
        },
        "grid": {
          "left": "1%",
          "right": "40",
          "bottom": "1%",
          "top": "25%",
          "containLabel": true
        },
        "series": [
          {
            "name": "电量",
            "type": "bar",
            "barWidth": 10,
            "itemStyle": {
              "color": {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [
                  {
                    "offset": 0,
                    "color": "#aed8ff"
                  },
                  {
                    "offset": 1,
                    "color": "#0184ff"
                  }
                ]
              },
              "barBorderRadius": [
                10,
                10,
                0,
                0
              ]
            },
            "data": [
              24517,
              26163,
              26920,
              24517,
              26163,
              26920,
              24517,
              26163,
              26920,
              24517,
              36163,
              36920,
              34517,
              36163,
              36920,
              34517,
              36163,
              36920,
              34517,
              36163,
              26920,
              24517,
              26163,
              26920,
              24517,
              26163,
              26920,
              24517,
              26163,
              26920,
            ]
          },
          {
            "name": "电费",
            "type": "bar",
            "barWidth": 10,
            "itemStyle": {
              "color": {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [
                  {
                    "offset": 0,
                    "color": "#ffdf92"
                  },
                  {
                    "offset": 1,
                    "color": "#ffba16"
                  }
                ]
              },
              "barBorderRadius": [
                10,
                10,
                0,
                0
              ]
            },
            "data": [
              20813.6006,
              24450.3354,
              25789.4828,
              20813.6006,
              24450.3354,
              25789.4828,
              20813.6006,
              24450.3354,
              25789.4828,
              20813.6006,
              24450.3354,
              25789.4828,
              20813.6006,
              24450.3354,
              25789.4828,
              20813.6006,
              24450.3354,
              35789.4828,
              30813.6006,
              34450.3354,
              35789.4828,
              30813.6006,
              34450.3354,
              35789.4828,
              20813.6006,
              24450.3354,
              25789.4828,
              20813.6006,
              24450.3354,
              25789.4828,
            ]
          }
        ]
      },
      barOption3: {
        "xAxis": [
          {
            "type": "category",
            "data": [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
              "29",
              "30",
              "31"
            ],
            "splitLine": {
              "show": false,
              "lineStyle": {
                "type": "dashed",
                "color": "#333333"
              }
            },
            "axisLabel": {
              "show": true,
              "textStyle": {
                "color": "#fff"
              }
            },
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": false
            }
          }
        ],
        "yAxis": [
          {
            "title": "能耗值（KWH）",
            "type": "value",
            "splitLine": {
              "lineStyle": {
                "type": "dashed",
                "color": "#333333"
              }
            },
            "axisLabel": {
              "show": true,
              "textStyle": {
                "color": "#fff"
              }
            },
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": false
            }
          }
        ],
        "color": [
          "#1cd66c"
        ],
        "backgroundColor": "",
        "tooltip": {
          "trigger": "axis",
          "confine": true,
          "axisPointer": {
            "animation": false
          }
        },
        "grid": {
          "left": "1%",
          "right": "40",
          "bottom": "1%",
          "top": "25%",
          "containLabel": true
        },
        "series": [
          {
            "name": "碳排放",
            "type": "line",
            "symbol": "none",
            "smooth": true,
            "data": [
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055",
              "32.702",
              "39.143",
              "31.055", 
            ],
            "areaStyle": {
              "color": {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [
                  {
                    "offset": 0,
                    "color": "#1cd66c"
                  },
                  {
                    "offset": 1,
                    "color": "transparent"
                  }
                ]
              }
            }
          }
        ]
      },


      selectTab: 0, //0今日1昨日2前日
      thisMonthData: [
        //电量
        { value: 11, name: "尖" },
        { value: 12, name: "峰" },
        { value: 11, name: "平" },
        { value: 10, name: "谷" },
      ], //当月数据
      thisMonthData2: [
        //电费
        { value: 12, name: "尖" },
        { value: 21, name: "峰" },
        { value: 23, name: "平" },
        { value: 18, name: "谷" },
      ], //当月数据
      lastMonthData: [
        //电量
        { value: 21, name: "尖" },
        { value: 16, name: "峰" },
        { value: 18, name: "平" },
        { value: 19, name: "谷" },
      ], //本月数据
      lastMonthData2: [
        //电费
        { value: 12, name: "尖", total: '5%' },
        { value: 11, name: "峰", total: '6%' },
        { value: 10, name: "平", total: '6%' },
        { value: 12, name: "谷", total: '6%' },
      ], //本月数据
      pieOption: {
        title: {
          text: "0",
          subtext: "总电费(元)",
          left: "26%",
          top: "40%",
          textAlign: "center",
          subtextStyle: {
            color: "#fff",
            fontSize: 13,
            lineHeight: 0,
          },
          textStyle: {
            // 图例的公用文本样式。
            fontSize: 20,
            color: "#fff",
          },
        },
        legend: {
          icon: "roundRect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 12, // 设置宽度
          itemHeight: 12, // 设置高度
          orient: "vertical",
          right: "6%",
          top: "center",
          itemGap: 24,
          formatter: function (name) {
            var dataIndex = 0;
            var data = pieOption.series[0].data;
            for (var i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                dataIndex = i;
                break;
              }
            }
            return (name +
              "电费" +
              " " + data[dataIndex].total
            );
          },
          textStyle: {
            // 图例的公用文本样式。
            fontSize: 16,
            color: "#fff",
          },
        },

        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}  ({d}%)",
        },
        series: [
          {
            type: "pie",
            label: {
              show: false,
            },
            data: [],
            color: ["#FF7B1D", "#FFBB1D", "#0084FF", "#34F5CB"],
            radius: ["56%", "70%"],
            center: ["27%", "50%"],
          },
        ],
      },
      barOption: {
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}",
          show: true,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#333333",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },
          data: ["尖电量", "峰电量", "平电量", "谷电量"],
        },
        yAxis: {
          type: "value",
          name: "电量(kW.h)",
          nameTextStyle: {
            color: "#fff", // 设置字体颜色为红色
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#333333",
            },
          },
        },
        grid: [
          {
            bottom: "14%",
            height: 130,
            containLabel: true,
          },
        ],
        series: [
          {
            data: [],
            type: "bar",
            barWidth: 25,
            itemStyle: {
              normal: {
                //这里是重点
                barBorderRadius: [5, 5, 0, 0],
                color: function (params) {
                  var colorList = ["#FF7B1D", "#FFBB1D", "#0084FF", "#34F5CB"];
                  return colorList[params.dataIndex];
                },
              },
            },
            showBackground: true,
          },
        ],
      },
      monthMaxNeed: 0,
      dayMaxNeed: 0,
      loadDeviceList: [],
      deviceNoToArchivesInfo: {},
      todayLoadLine: [],
      dayMaxLoad: 0,
      monthMaxLoad: 0,
      nowLoadDeviceFromname: undefined,
      newdayMaxNeed: 0, //日最大需量
      newmonthMaxNeed: 0, //newmonthMaxNeed
      aaa: true,
      idFlag: true,
      heights: document.getElementById("app").clientHeight - 590, //屏幕高度 - 导航栏高度
      fullscreen: false,
      timerNull: null,
      timerYMD: "",
      timerWeek: "",
      timerHMS: "",
      vchartData: {
        "xAxis": {
          "type": "category",
          "splitLine": {
            "show": false,
            "lineStyle": {
              "type": "dashed",
              "color": "#333333"
            }
          },
          "axisLabel": {
            "show": true,
            "interval": 23,
            "textStyle": {
              "color": "#fff"
            }
          },
          "axisTick": {
            "show": false
          },
          "axisLine": {
            "show": false
          },
          "data": [
            "00:00",
            "00:05",
            "00:10",
            "00:15",
            "00:20",
            "00:25",
            "00:30",
            "00:35",
            "00:40",
            "00:45",
            "00:50",
            "00:55",
            "01:00",
            "01:05",
            "01:10",
            "01:15",
            "01:20",
            "01:25",
            "01:30",
            "01:35",
            "01:40",
            "01:45",
            "01:50",
            "01:55",
            "02:00",
            "02:05",
            "02:10",
            "02:15",
            "02:20",
            "02:25",
            "02:30",
            "02:35",
            "02:40",
            "02:45",
            "02:50",
            "02:55",
            "03:00",
            "03:05",
            "03:10",
            "03:15",
            "03:20",
            "03:25",
            "03:30",
            "03:35",
            "03:40",
            "03:45",
            "03:50",
            "03:55",
            "04:00",
            "04:05",
            "04:10",
            "04:15",
            "04:20",
            "04:25",
            "04:30",
            "04:35",
            "04:40",
            "04:45",
            "04:50",
            "04:55",
            "05:00",
            "05:05",
            "05:10",
            "05:15",
            "05:20",
            "05:25",
            "05:30",
            "05:35",
            "05:40",
            "05:45",
            "05:50",
            "05:55",
            "06:00",
            "06:05",
            "06:10",
            "06:15",
            "06:20",
            "06:25",
            "06:30",
            "06:35",
            "06:40",
            "06:45",
            "06:50",
            "06:55",
            "07:00",
            "07:05",
            "07:10",
            "07:15",
            "07:20",
            "07:25",
            "07:30",
            "07:35",
            "07:40",
            "07:45",
            "07:50",
            "07:55",
            "08:00",
            "08:05",
            "08:10",
            "08:15",
            "08:20",
            "08:25",
            "08:30",
            "08:35",
            "08:40",
            "08:45",
            "08:50",
            "08:55",
            "09:00",
            "09:05",
            "09:10",
            "09:15",
            "09:20",
            "09:25",
            "09:30",
            "09:35",
            "09:40",
            "09:45",
            "09:50",
            "09:55",
            "10:00",
            "10:05",
            "10:10",
            "10:15",
            "10:20",
            "10:25",
            "10:30",
            "10:35",
            "10:40",
            "10:45",
            "10:50",
            "10:55",
            "11:00",
            "11:05",
            "11:10",
            "11:15",
            "11:20",
            "11:25",
            "11:30",
            "11:35",
            "11:40",
            "11:45",
            "11:50",
            "11:55",
            "12:00",
            "12:05",
            "12:10",
            "12:15",
            "12:20",
            "12:25",
            "12:30",
            "12:35",
            "12:40",
            "12:45",
            "12:50",
            "12:55",
            "13:00",
            "13:05",
            "13:10",
            "13:15",
            "13:20",
            "13:25",
            "13:30",
            "13:35",
            "13:40",
            "13:45",
            "13:50",
            "13:55",
            "14:00",
            "14:05",
            "14:10",
            "14:15",
            "14:20",
            "14:25",
            "14:30",
            "14:35",
            "14:40",
            "14:45",
            "14:50",
            "14:55",
            "15:00",
            "15:05",
            "15:10",
            "15:15",
            "15:20",
            "15:25",
            "15:30",
            "15:35",
            "15:40",
            "15:45",
            "15:50",
            "15:55",
            "16:00",
            "16:05",
            "16:10",
            "16:15",
            "16:20",
            "16:25",
            "16:30",
            "16:35",
            "16:40",
            "16:45",
            "16:50",
            "16:55",
            "17:00",
            "17:05",
            "17:10",
            "17:15",
            "17:20",
            "17:25",
            "17:30",
            "17:35",
            "17:40",
            "17:45",
            "17:50",
            "17:55",
            "18:00",
            "18:05",
            "18:10",
            "18:15",
            "18:20",
            "18:25",
            "18:30",
            "18:35",
            "18:40",
            "18:45",
            "18:50",
            "18:55",
            "19:00",
            "19:05",
            "19:10",
            "19:15",
            "19:20",
            "19:25",
            "19:30",
            "19:35",
            "19:40",
            "19:45",
            "19:50",
            "19:55",
            "20:00",
            "20:05",
            "20:10",
            "20:15",
            "20:20",
            "20:25",
            "20:30",
            "20:35",
            "20:40",
            "20:45",
            "20:50",
            "20:55",
            "21:00",
            "21:05",
            "21:10",
            "21:15",
            "21:20",
            "21:25",
            "21:30",
            "21:35",
            "21:40",
            "21:45",
            "21:50",
            "21:55",
            "22:00",
            "22:05",
            "22:10",
            "22:15",
            "22:20",
            "22:25",
            "22:30",
            "22:35",
            "22:40",
            "22:45",
            "22:50",
            "22:55",
            "23:00",
            "23:05",
            "23:10",
            "23:15",
            "23:20",
            "23:25",
            "23:30",
            "23:35",
            "23:40",
            "23:45",
            "23:50",
            "23:55"
          ]
        },
        "yAxis": {
          "type": "value",
          "name": "",
          "splitLine": {
            "lineStyle": {
              "type": "dashed",
              "color": "#333333"
            }
          },
          "axisLabel": {
            "show": true,
            "textStyle": {
              "color": "#fff"
            }
          },
          "axisTick": {
            "show": false
          },
          "axisLine": {
            "show": false
          }
        },
        "color": [
          "#FFBB1D",
          "#34F5CB",
          "#0084FF"
        ],
        "legend": {
          "data": [
            "前日负荷",
            "昨日负荷",
            "今日负荷"
          ],
          "x": "right",
          "y": "top",
          "padding": [
            10,
            40,
            0,
            0
          ],
          "textStyle": {
            "color": "#fff"
          },
          "orient": "horizontal"
        },
        "tooltip": {
          "trigger": "axis",
          "axisPointer": {
            "label": {
              "backgroundColor": "#6a7985"
            }
          }
        },
        "backgroundColor": "",
        "grid": {
          "left": "3%",
          "right": "3%",
          "bottom": "8%",
          "top": "14%",
          "containLabel": true
        },
        "series": [
          {
            "data": [
              "384.00",
              "373.20",
              "372.00",
              "373.20",
              "381.60",
              "385.20",
              "279.60",
              "298.80",
              "319.20",
              "403.20",
              "385.20",
              "388.80",
              "408.00",
              "384.00",
              "396.00",
              "363.60",
              "355.20",
              "344.40",
              "327.60",
              "405.60",
              "408.00",
              "392.40",
              "404.40",
              "394.80",
              "394.80",
              "309.60",
              "295.20",
              "295.20",
              "406.80",
              "392.40",
              "416.40",
              "327.60",
              "334.80",
              "336.00",
              "424.80",
              "439.20",
              "424.80",
              "424.80",
              "430.80",
              "410.40",
              "325.20",
              "296.40",
              "361.20",
              "378.00",
              "360.00",
              "343.20",
              "356.40",
              "356.40",
              "308.40",
              "256.80",
              "254.40",
              "253.20",
              "361.20",
              "372.00",
              "358.80",
              "376.80",
              "379.20",
              "265.20",
              "280.80",
              "320.40",
              "343.20",
              "351.60",
              "369.60",
              "345.60",
              "247.20",
              "238.80",
              "319.20",
              "340.80",
              "321.60",
              "322.80",
              "243.60",
              "211.20",
              "210.00",
              "306.00",
              "290.40",
              "291.60",
              "291.60",
              "288.00",
              "290.40",
              "201.60",
              "217.20",
              "219.60",
              "296.40",
              "315.60",
              "375.60",
              "394.80",
              "388.80",
              "363.60",
              "258.00",
              "254.40",
              "274.80",
              "342.00",
              "345.60",
              "349.20",
              "344.40",
              "399.60",
              "406.80",
              "368.40",
              "458.40",
              "490.80",
              "466.80",
              "487.20",
              "478.80",
              "496.80",
              "488.40",
              "478.80",
              "591.60",
              "571.20",
              "652.80",
              "648.00",
              "698.40",
              "691.20",
              "582.00",
              "680.40",
              "706.80",
              "681.60",
              "697.20",
              "531.60",
              "620.40",
              "638.40",
              "609.60",
              "571.20",
              null,
              "609.60",
              "559.20",
              "520.80",
              "554.40",
              "573.60",
              "504.00",
              "483.60",
              "616.80",
              "615.60",
              "516.00",
              "508.80",
              "508.80",
              "517.20",
              "500.40",
              "448.80",
              "334.80",
              "356.40",
              "346.80",
              "439.20",
              "433.20",
              "475.20",
              "387.60",
              "397.20",
              "493.20",
              "520.80",
              "729.60",
              "706.80",
              "610.80",
              "625.20",
              "555.60",
              "562.80",
              "730.80",
              "740.40",
              "672.00",
              "613.20",
              "708.00",
              "696.00",
              "726.00",
              "628.80",
              "624.00",
              "658.80",
              "637.20",
              "786.00",
              "808.80",
              "718.80",
              "650.40",
              "704.40",
              "808.80",
              "806.40",
              "850.80",
              "763.20",
              "676.80",
              "708.00",
              "681.60",
              "789.60",
              "774.00",
              "747.60",
              "789.60",
              "766.80",
              "842.40",
              "817.20",
              "736.80",
              "783.60",
              "657.60",
              "589.20",
              "636.00",
              "738.00",
              "790.80",
              "764.40",
              "860.40",
              "717.60",
              "622.80",
              "732.00",
              "720.00",
              "837.60",
              "708.00",
              "927.60",
              "691.20",
              "873.60",
              "882.00",
              "867.60",
              "762.00",
              "717.60",
              "715.20",
              "642.00",
              "852.00",
              "687.60",
              "771.60",
              "658.80",
              "696.00",
              "620.40",
              "538.80",
              "463.20",
              "621.60",
              "550.80",
              "408.00",
              "507.60",
              "637.20",
              "483.60",
              "638.40",
              "636.00",
              "510.00",
              "562.80",
              "462.00",
              "429.60",
              "658.80",
              "554.40",
              "658.80",
              "516.00",
              "554.40",
              "452.40",
              "663.60",
              "576.00",
              "595.20",
              "556.80",
              "492.00",
              "552.00",
              "570.00",
              "1105.20",
              "1062.00",
              "1080.00",
              "1024.80",
              "975.60",
              "996.00",
              "1063.20",
              "882.00",
              "940.80",
              "1076.40",
              "1083.60",
              "894.00",
              "1068.00",
              "938.40",
              "1036.80",
              "932.40",
              "920.40",
              "1039.20",
              "964.80",
              "1034.40",
              "883.20",
              "958.80",
              "1017.60",
              "1053.60",
              "730.80",
              "826.80",
              "727.20",
              "963.60",
              "847.20",
              "915.60",
              "915.60",
              "835.20",
              "948.00",
              "792.00",
              "943.20",
              "1000.80",
              "879.60",
              "961.20",
              "1029.60",
              "1042.80",
              "1158.00",
              "1060.80",
              "1040.40",
              "932.40",
              "1065.60",
              "1046.40",
              "1105.20"
            ],
            "type": "line",
            "markPoint": {
              "data": [
                {
                  "name": "最大值",
                  "type": "max"
                }
              ]
            },
            "areaStyle": {
              "color": {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [
                  {
                    "offset": 0,
                    "color": "#ffcd1f"
                  },
                  {
                    "offset": 1,
                    "color": "transparent"
                  }
                ]
              }
            },
            "name": "前日负荷"
          },
          {
            "data": [
              "1854.00",
              "1813.20",
              "1905.60",
              "1831.20",
              "1909.20",
              "1887.60",
              "1784.40",
              "1788.00",
              "1756.80",
              "1822.80",
              "1834.80",
              "1712.40",
              "1884.00",
              "1860.00",
              "1777.20",
              "1759.20",
              "1720.80",
              "1854.00",
              "1905.60",
              "1784.40",
              "1986.00",
              "1873.20",
              "1592.40",
              "1779.60",
              "1812.00",
              "1761.60",
              "1900.80",
              "1818.00",
              "1906.80",
              "1735.20",
              "1731.60",
              "1807.20",
              "1948.80",
              "1780.80",
              "1782.00",
              "1666.80",
              "1887.60",
              "1845.60",
              "1810.80",
              "1542.00",
              "1770.00",
              "1886.40",
              "1855.20",
              "1767.60",
              "1830.00",
              "1881.60",
              "1736.40",
              "1928.40",
              "1804.80",
              "1604.40",
              "1893.60",
              "1477.20",
              "1669.20",
              "1334.40",
              "1531.20",
              "1669.20",
              "1468.80",
              "1620.00",
              "1806.00",
              "1562.40",
              "1810.80",
              "1846.80",
              "2023.20",
              "1905.60",
              "1821.60",
              "2032.80",
              "1957.20",
              "2097.60",
              "2072.40",
              "1988.40",
              "1780.80",
              "2020.80",
              "1963.20",
              "2037.60",
              "2124.00",
              "2295.60",
              "2269.20",
              "2228.40",
              "2223.60",
              "2304.00",
              "2328.00",
              "2206.80",
              "2283.60",
              "2115.60",
              "2215.20",
              "2456.40",
              "2528.40",
              "2239.20",
              "2266.80",
              "2323.20",
              "2438.40",
              "2829.60",
              "2762.40",
              "2762.40",
              "2721.60",
              "2995.20",
              "3018.00",
              "3068.40",
              "3140.40",
              "3096.00",
              "3577.20",
              "3639.60",
              "3656.40",
              "3385.20",
              "3397.20",
              "3448.80",
              "3565.20",
              "3308.40",
              "3439.20",
              "3324.00",
              "3394.80",
              "3484.80",
              "3414.00",
              "3409.20",
              "3484.80",
              "3495.60",
              "3661.20",
              "3428.40",
              "3687.60",
              "3606.00",
              "3417.60",
              "3826.80",
              "3722.40",
              "3693.60",
              "3544.80",
              "3541.20",
              "3541.20",
              "3639.60",
              "3668.40",
              "3523.20",
              "3493.20",
              "3562.80",
              "3627.60",
              "3661.20",
              "3670.80",
              "3438.00",
              "3548.40",
              "3574.80",
              "3447.60",
              "3500.40",
              "3411.60",
              "3408.00",
              "3162.00",
              "3154.80",
              "3553.20",
              "3501.60",
              "3396.00",
              "3342.00",
              "3342.00",
              "3385.20",
              "3530.40",
              "3315.60",
              "3388.80",
              "3423.60",
              "3289.20",
              "3391.20",
              "3375.60",
              "3502.80",
              "3831.60",
              "3530.40",
              "3726.00",
              "3758.40",
              "3570.00",
              "3792.00",
              "3663.60",
              "3771.60",
              "3572.40",
              "3632.40",
              "3649.20",
              "3745.20",
              "3451.20",
              "3573.60",
              "3795.60",
              "3669.60",
              "3750.00",
              "3908.40",
              "3752.40",
              "4072.80",
              "4028.40",
              "3966.00",
              "3892.80",
              "3692.40",
              "3892.80",
              "3680.40",
              "3606.00",
              "3513.60",
              "3507.60",
              "3770.40",
              "3770.40",
              "3532.80",
              "3633.60",
              "3602.40",
              "3681.60",
              "3553.20",
              "3626.40",
              "3650.40",
              "3421.20",
              "3825.60",
              "3601.20",
              "3535.20",
              "3558.00",
              "3558.00",
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            ],
            "type": "line",
            "areaStyle": {
              "color": {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [
                  {
                    "offset": 0,
                    "color": "#0084ff"
                  },
                  {
                    "offset": 1,
                    "color": "transparent"
                  }
                ]
              }
            },
            "markPoint": {
              "data": [
                {
                  "name": "最大值",
                  "type": "max"
                }
              ]
            },
            "name": "今日负荷"
          },
          {
            "data": [
              "1149.60",
              "1216.80",
              "1082.40",
              "1054.80",
              "1063.20",
              "1141.20",
              "1148.40",
              "1050.00",
              "986.40",
              "1029.60",
              "962.40",
              "1164.00",
              "1002.00",
              "957.60",
              "1213.20",
              "1017.60",
              "1014.00",
              "1092.00",
              "1118.40",
              "1094.40",
              "1268.40",
              "1162.80",
              "1171.20",
              "1069.20",
              "1221.60",
              "1124.40",
              "1107.60",
              "1126.80",
              "1106.40",
              "1236.00",
              "1129.20",
              "1147.20",
              "1155.60",
              "1051.20",
              "1238.40",
              "1149.60",
              "1117.20",
              "1176.00",
              "1021.20",
              "880.80",
              "930.00",
              "1113.60",
              "1126.80",
              "1047.60",
              "1046.40",
              "1035.60",
              "932.40",
              "1023.60",
              "1011.60",
              "1029.60",
              "1027.20",
              "1034.40",
              "1014.00",
              "931.20",
              "1093.20",
              "1172.40",
              "1095.60",
              "1005.60",
              "1027.20",
              "1026.00",
              "975.60",
              "1104.00",
              "1178.40",
              "1267.20",
              "1173.60",
              "1221.60",
              "1153.20",
              "1224.00",
              "1110.00",
              "1184.40",
              "1167.60",
              "1346.40",
              "1180.80",
              "1119.60",
              "1195.20",
              "1287.60",
              "1311.60",
              "1292.40",
              "1357.20",
              "1357.20",
              "1285.20",
              "1392.00",
              "1440.00",
              "1431.60",
              "1357.20",
              "1668.00",
              "1773.60",
              "1647.60",
              "1768.80",
              "1858.80",
              "2209.20",
              "2241.60",
              "2348.40",
              "2389.20",
              "2552.40",
              "2659.20",
              "2558.40",
              "2739.60",
              "3010.80",
              "2880.00",
              "2962.80",
              "3150.00",
              "3120.00",
              "3153.60",
              "3121.20",
              "3154.80",
              "3172.80",
              "3262.80",
              null,
              "3288.00",
              "3279.60",
              "3279.60",
              "3409.20",
              "3318.00",
              "3470.40",
              "3306.00",
              "3285.60",
              "3388.80",
              "3415.20",
              "3470.40",
              "3505.20",
              "3524.40",
              "3517.20",
              "3387.60",
              "3427.20",
              "3416.40",
              "3614.40",
              "3688.80",
              "3580.80",
              "3301.20",
              "3637.20",
              "3578.40",
              "3534.00",
              "3480.00",
              "3652.80",
              "3578.40",
              "3489.60",
              "3280.80",
              "3121.20",
              "3058.80",
              "3242.40",
              "3162.00",
              "3162.00",
              "2781.60",
              "2834.40",
              "2875.20",
              "3021.60",
              "2913.60",
              "2839.20",
              "2959.20",
              "3456.00",
              "3726.00",
              "3726.00",
              "3772.80",
              "3676.80",
              "3404.40",
              "3506.40",
              "3553.20",
              "3424.80",
              "3535.20",
              "3723.60",
              "3604.80",
              "3604.80",
              "3679.20",
              "3476.40",
              "3573.60",
              "3474.00",
              null,
              "0.00",
              null,
              "3537.60",
              "3625.20",
              "3658.80",
              "3440.40",
              "3334.80",
              "3668.40",
              "3702.00",
              "3446.40",
              "3801.60",
              "3538.80",
              "3741.60",
              "3927.60",
              "3914.40",
              "3733.20",
              "3576.00",
              "3226.80",
              "3452.40",
              "3535.20",
              "3564.00",
              "3556.80",
              "3277.20",
              "3501.60",
              "3420.00",
              "3504.00",
              "3343.20",
              "3571.20",
              "3410.40",
              "3445.20",
              "3286.80",
              "3486.00",
              "3372.00",
              "3296.40",
              "3476.40",
              "3542.40",
              "3394.80",
              "3559.20",
              "3295.20",
              "3476.40",
              "3282.00",
              "3420.00",
              "3142.80",
              "3217.20",
              "3028.80",
              "2895.60",
              "2962.80",
              "2655.60",
              "2830.80",
              "2830.80",
              "2982.00",
              "2856.00",
              "2856.00",
              "2714.40",
              "2852.40",
              "2806.80",
              "2796.00",
              "2660.40",
              "2844.00",
              "2899.20",
              "2857.20",
              "2594.40",
              "2648.40",
              "2618.40",
              "2362.80",
              "2527.20",
              "2638.80",
              "2630.40",
              "2487.60",
              "2665.20",
              "2650.80",
              "2589.60",
              "2571.60",
              "2464.80",
              "2510.40",
              "2601.60",
              "2594.40",
              "2334.00",
              "2430.00",
              "2210.40",
              "2247.60",
              "2191.20",
              "2304.00",
              "2308.80",
              "2126.40",
              "2131.20",
              "1998.00",
              "2256.00",
              "2498.40",
              "2162.40",
              "2415.60",
              "2439.60",
              "2097.60",
              "2176.80",
              "2126.40",
              "2176.80",
              "2176.80",
              "1923.60",
              "2071.20",
              "1971.60",
              "1926.00",
              "2049.60",
              "2008.80",
              "1988.40",
              "2064.00",
              "2100.00",
              "2032.80",
              "1927.20",
              "1978.80",
              "1699.20",
              "1653.60",
              "1675.20",
              "1710.00",
              "1653.60",
              "1646.40",
              "1683.60",
              "1664.40",
              "1653.60",
              "1897.20",
              "1929.60"
            ],
            "type": "line",
            "markPoint": {
              "data": [
                {
                  "name": "最大值",
                  "type": "max"
                }
              ]
            },
            "areaStyle": {
              "color": {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [
                  {
                    "offset": 0,
                    "color": "#34f5cb"
                  },
                  {
                    "offset": 1,
                    "color": "transparent"
                  }
                ]
              }
            },
            "name": "昨日负荷"
          }
        ]
      },
    };
  },
  computed: {

    // ‌环比增长速度‌：计算公式为 环比增长速度 = (本期数 - 上期数) ÷ 上期数 × 100%
    a2() {
      if (this.oneData.a == 0 || this.oneData.a1 == 0) {
        return 0;
      }

      return (
        ((this.oneData.a - this.oneData.a1) / this.oneData.a1) *
        100
      ).toFixed(2);
    },
    b2() {
      if (this.oneData.b == 0 || this.oneData.b1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.b - this.oneData.b1) / this.oneData.b1) *
        100
      ).toFixed(2);
    },
    c2() {
      if (this.oneData.c == 0 || this.oneData.c1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.c - this.oneData.c1) / this.oneData.c1) *
        100
      ).toFixed(2);
    },
    d2() {
      if (this.oneData.d == 0 || this.oneData.d1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.d - this.oneData.d1) / this.oneData.d1) *
        100
      ).toFixed(2);
    },
    e2() {
      if (this.oneData.e == 0 || this.oneData.e1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.e - this.oneData.e1) / this.oneData.e1) *
        100
      ).toFixed(2);
    },
    f2() {
      if (this.oneData.f == 0 || this.oneData.f1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.f - this.oneData.f1) / this.oneData.f1) *
        100
      ).toFixed(2);
    },
    g2() {
      if (this.oneData.g == 0 || this.oneData.g1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.g - this.oneData.g1) / this.oneData.g1) *
        100
      ).toFixed(2);
    },
    h2() {
      if (this.oneData.h == 0 || this.oneData.h1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.h - this.oneData.h1) / this.oneData.h1) *
        100
      ).toFixed(2);
    },
    i2() {
      if (this.oneData.i == 0 || this.oneData.i1 == 0) {
        return 0;
      }
      return (
        ((this.oneData.i - this.oneData.i1) / this.oneData.i1) *
        100
      ).toFixed(2);
    },



    realTimeValueStore() {
      return this.$store.realTimeValueStore;
    },
    monthMaxRate() {
      var rate = 0;
      try {
        rate = parseFloat(
          (this.monthMaxLoad / this.loadCapacity) * 100
        ).toFixed(2);
        if (isNaN(rate)) {
          return 0;
        }
      } catch (e) { }
      if (this.loadCapacity == 0) {
        return 0;
      }
      return rate;
    },
    dayMaxRate() {
      var rate = 0;
      try {
        rate = parseFloat((this.dayMaxLoad / this.loadCapacity) * 100).toFixed(
          2
        );
        if (isNaN(rate)) {
          return 0;
        }
      } catch (e) { }
      if (this.loadCapacity == 0) {
        return 0;
      }
      return rate;
    },
    //实时负荷
    realLoad() {
      if (isempty(this.nowLoadDeviceFromname)) {
        return "--";
      }
      var values = this.realTimeValueStore.getters.getValue(
        this.nowLoadDeviceFromname
      );
      var count = 0;
      for (var i = 0, len = values.length; i < len; i++) {
        if (values[i] != undefined) {
          count += parseFloat(values[i]);
        }
      }

      return cutDigital(count);
    },
    tabStyle() {
      return (index) => {
        if (index == this.selectTab) {
          return {
            color: "#0062FF",
          };
        } else {
          return {
            color: "#fff",
          };
        }
      };
    },
    xList() {
      var list = [];
      for (var h = 0, len = 24; h < len; h++) {
        for (var m = 0, lenm = 60; m < lenm; m += 5) {
          list.push((h < 10 ? "0" : "") + h + ":" + (m < 10 ? "0" : "") + m);
        }
      }
      return list;
    },
    getLine() {
      return {
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#333333",
            },
          },
          axisLabel: {
            show: true,
            interval: 23,
            textStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },

          data: this.xList,
        },
        yAxis: {
          type: "value",
          name: "",
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#333333",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },
        },
        color: ["#FFBB1D", "#34F5CB", "#0084FF"],
        legend: {
          data: ["前日负荷", "昨日负荷", "今日负荷"],
          x: "right",
          y: "top",
          padding: [10, 40, 0, 0],
          textStyle: {
            color: '#fff' // 这里设置图例的字体颜色为红色
          },
          orient: "horizontal",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        backgroundColor: "",
        grid: {
          left: "3%",
          right: "3%",
          bottom: "8%",
          top: "14%",
          containLabel: true,
        },
        series: this.todayLoadLine,
      };
    },
    nowUnit() {
      var nowunit = this.$store.unitStore.getters.getNowUnit;
      findDemand({
        unitId: nowunit.id,
      }).then((res) => {
        this.newdayMaxNeed = res.data.nowDayDemand;
        this.newmonthMaxNeed = res.data.nowMonthDemand;
      });
      return nowunit;
    },
  },
  watch: {
    nowLoadDeviceFromname(nv, ov) {
      if (!isempty(ov)) {
        //移除旧变量
        this.realTimeValueStore.commit("removeKeys", ov);
      }
      if (!isempty(nv)) {
        this.realTimeValueStore.commit("addKeys", nv);
      }
    },
    nowUnit(nv, ov) {

    },
    getLine(nv, ov) {

    },
  },
  destroyed() {

  },
  mounted() {


    pieOption = this.pieOption;

    this.$refs.vchart.setData(this.barOption3, true);
    this.$refs.vchart2.setData(this.barOption2, true);
    this.$refs.vchartLine.setData(this.vchartData, true);

    this.pieOption.title.text = 0;
    this.pieOption.series[0].data = [
      //电费
      { value: 0, name: "尖", total: '0%' },
      { value: 0, name: "峰", total: '0%' },
      { value: 0, name: "平", total: '0%' },
      { value: 0, name: "谷", total: '0%' },
    ];
    this.barOption.series[0].data = [
      //电量
      { value: 0, name: "尖" },
      { value: 0, name: "峰" },
      { value: 0, name: "平" },
      { value: 0, name: "谷" },
    ];
    pieOption = this.pieOption;
    this.changSelectTab(0);
    this.$refs.vchartPie.setData(this.pieOption, true);
    this.$refs.vchartBar.setData(this.barOption, true);

    this.timerNull = setInterval(() => {
      // 获取当前日期
      const date = new Date();

      // 获取年份(4位,如2022)
      const year = date.getFullYear();

      // 获取月份(0-11,所以获取月份要加1)
      const month = date.getMonth() + 1;

      // 获取日期
      const day = date.getDate();

      // 获取周几(0-6,0表示周日)
      const week = date.getDay();

      // 24小时制时间
      const hours = date.getHours();

      // 分钟
      const minutes = date.getMinutes();

      // 秒
      const seconds = date.getSeconds();
      this.timerYMD = year + "年" + month + "月" + day + "日";
      this.timerWeek =
        "星期" + ["日", "一", "二", "三", "四", "五", "六"][week];
      this.timerHMS =
        (hours > 10 ? hours : "0" + hours) +
        ":" +
        (minutes > 10 ? minutes : "0" + minutes) +
        ":" +
        (seconds > 10 ? seconds : "0" + seconds);
    }, 1000);
  },

  methods: {
    getPowerValue() {
      this.oneData = {
        a: 0, //昨日电量
        a1: 0, //昨日电量 同比
        b: 0, //本月电量
        b1: 0, //本月电量 同比
        c: 0, //今年电量
        c1: 0, //今年电量 同比

        d: 0, //昨日电费
        d1: 0, //昨日电费 同比
        e: 0, //本月电费
        e1: 0, //上月电费 同比
        f: 0, //今年电费
        f1: 0, //今年电费 同比

        g: 0, //昨日碳排量
        g1: 0, //昨日碳排量 同比
        h: 0, //本月碳排量
        h1: 0, //本月碳排量 同比
        i: 0, //今年碳排量
        i1: 0, //今年碳排量 同比
      }
      this.pieOption.title.text = 0;
      this.pieOption.series[0].data = [
        //电费
        { value: 0, name: "尖", total: '0%' },
        { value: 0, name: "峰", total: '0%' },
        { value: 0, name: "平", total: '0%' },
        { value: 0, name: "谷", total: '0%' },
      ];
      this.barOption.series[0].data = [
        //电量
        { value: 0, name: "尖" },
        { value: 0, name: "峰" },
        { value: 0, name: "平" },
        { value: 0, name: "谷" },
      ];
      pieOption = this.pieOption;

      this.$refs.vchartPie.setData(this.pieOption, true);
      this.$refs.vchartBar.setData(this.barOption, true);


      var unitId = this.nowUnit.id;
      var now = new Date();
      var nowTime = now.getTime();
      var year = now.getFullYear();
      var month = now.getMonth();
      var day = now.getDate();

      var nowZero = new Date(year, month, day).getTime();



      var params = {
        appType: 'power',
        unitId: this.nowUnit.id
      }




    },
    //转换
    coCount(val) {
      if (!val) {
        return 0;
      }
      return ((val * this.co2TranslateRatio) / 1000).toFixed(3);
    },
    powerDate() {
      if (!isempty(this.nowUnit.id)) {
        var id = this.nowUnit.id;

        var d = {
          timeStamp: new Date().getTime(),
          unitId: this.nowUnit.id,
        };

      }
    },
    initData() {
      let atListDay = ""; //月最后一天
      let dataType = "";
      var nowdays = new Date();
      var year = nowdays.getFullYear();
      var month = nowdays.getMonth();
      if (month == 0) {
        month = 12;
        year = year - 1;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var myDate = new Date(year, month, 0);
      var endDate = year + "-" + month + "-" + myDate.getDate();
      switch (this.selectTab) {
        case 0:
          dataType = "当月";
          atListDay = nowdays.getTime();
          break;
        case 1:
          dataType = "上月";
          atListDay = endDate.getTime();
          break;
      }

    },
    changSelectTab(value) {
      this.selectTab = value;
      switch (value) {
        case 0:
          this.pieOption.title.text = this.oneData.e; //本月
          this.pieOption.series[0].data = this.thisMonthData2;
          this.barOption.series[0].data = this.thisMonthData;
          break;
        case 1:
          this.pieOption.title.text = this.oneData.e1; //上月
          this.pieOption.series[0].data = this.lastMonthData2;
          this.barOption.series[0].data = this.lastMonthData;
          break;
      }
      pieOption = this.pieOption;
      var d = 0;
      this.pieOption.series[0].data.map(v => {
        d += Number(v.value);
      })
      this.pieOption.series[0].data.map(v => {
        v.total = (v.value / d * 100).toFixed(2) + '%'
      })

      this.$refs.vchartPie.setData(this.pieOption, true);
      this.$refs.vchartBar.setData(this.barOption, true);
    },
    getLoadValue(unitId) {
      //获取单位相关的数据
      if (isempty(unitId)) {
        return;
      }
      //获取变压器负荷设备列表
      this.$api.deviceApi.getDeviceListByDeviceType(
        unitId,
        "load",
        (respon) => {
          this.loadDeviceList = respon;
          this.$api.archivesApi.getArchivesInfoByVirtualDeviceNos(
            respon.map((item) => item.deviceno).join(","),
            (tree) => {
              this.deviceNoToArchivesInfo = tree;
            }
          );
        }
      );
      //查询月最大需量
      this.$api.powerApi.getMonthMaxLoadDemand(
        unitId,
        new Date().getTime(),
        (respon) => {
          this.monthMaxNeed = isempty(respon) ? "--" : respon;
        }
      );
      //查询日最大需量
      this.$api.powerApi.getDayMaxLoadDemand(
        unitId,
        new Date().getTime(),
        (respon) => {
          this.dayMaxNeed = isempty(respon) ? "--" : respon;
        }
      );
      //查询日最大负荷
      this.$api.powerApi.getDayMaxLoad(
        unitId,
        new Date().getTime(),
        (respon) => {
          this.dayMaxLoad = isempty(respon) ? "--" : respon;
        }
      );
      //查询月最大负荷
      this.$api.powerApi.getMonthMaxLoad(
        unitId,
        new Date().getTime(),
        (respon) => {
          this.monthMaxLoad = isempty(respon) ? "--" : respon;
        }
      );
      //获取实时负荷
      this.$api.powerApi.getLoadFromnameByUnitId(unitId, (respon) => {
        this.nowLoadDeviceFromname = isempty(respon) ? "--" : respon;
      });
      //获取当日负荷曲线
      var ser = [];
      this.$api.powerApi.getUnitDayLoadValues(
        unitId,
        new Date(getDay(-2) + " 00:00:00").getTime(),
        (respon) => {
          ser.push({
            data: respon,
            type: "line",
            // color: "#FFBB1D",
            markPoint: {
              data: [
                {
                  name: "最大值",
                  type: "max",
                },
              ],
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#ffcd1f" },
                { offset: 1, color: "transparent" },
              ]),
            },
            name: "前日负荷",
          });
          this.$api.powerApi.getUnitDayLoadValues(
            unitId,
            new Date(getDay(-1) + " 00:00:00").getTime(),
            (respon2) => {
              ser.push({
                data: respon2,
                type: "line",
                // color: "#34F5CB",
                markPoint: {
                  data: [
                    {
                      name: "最大值",
                      type: "max",
                    },
                  ],
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#34f5cb" },
                    { offset: 1, color: "transparent" },
                  ]),
                },
                name: "昨日负荷",
              });
            }
          );
          this.$api.powerApi.getUnitDayLoadValues(
            unitId,
            new Date(getDay(0) + " 00:00:00").getTime(),
            (respon3) => {
              ser.push({
                data: respon3,
                type: "line",
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#0084ff" },
                    { offset: 1, color: "transparent" },
                  ]),
                },
                // color: "#0084FF",
                markPoint: {
                  data: [
                    {
                      name: "最大值",
                      type: "max",
                    },
                  ],
                },
                name: "今日负荷",
              });
              this.todayLoadLine = ser;
            }
          );
        }
      );
    },
    handleFullScreen() {
      this.idFlag = false;
      // 此处可根据获取节点进行区域全屏事件
      let element = document.getElementsByClassName("kanban")[0];
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
      setTimeout(() => {
        this.heights = document.getElementById("app").clientHeight - 590; //屏幕高度 - 导航栏高度
      }, 100);
    },
    bbb() {
      this.$router.push("/usePowerUnit");
    },
  },
  filters: {
    // 转换时间戳
    date_format: function (value) {
      //value就是插值的数据
      if (value == "") {
        return "";
      }
      return value.replace(/-/g, "");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-icon-top {
  color: #ff3d27 !important;
}

/deep/.el-icon-bottom {
  color: #20c135 !important;
}

.span2 {
  color: #20c135 !important;
}

.span3 {
  color: #ff3d27 !important;
}

.ttt {
  width: 100%;
  height: 43px;
  background: url(../../assets/enterprise/biao.png) no-repeat;
  background-size: 100% 100%;
  font-family: YouSheBiaoTiHei;
  font-size: 18px;
  font-weight: bold;
  box-sizing: border-box;
  padding-left: 29px;
}

.ttt2 {
  background: url(../../assets/enterprise/biao2.png) no-repeat;
  background-size: 100% 100%;
}

.hang2 {
   height: 31vh;
  display: flex;
  flex-direction: column;
}
.hang2 .cen{
  flex: 1;
}

.hang {
  display: flex;
  justify-content: space-between;
  min-height: 212px;
  position: relative;

  .peakChart {
    display: flex;
    width: 100%;
  }

  .tab-label {
    position: absolute;
    right: 0;
    top: 6px;
    display: flex;
    align-items: center;

    .tab-label-span {
      cursor: pointer;
      font-size: 14px;
      font-weight: bold;
      margin-right: 12px;
    }
  }

  .left {
    width: calc(50% - 6px);

    .ul {
      width: 35%;
      padding-left: 30px;
    }

    .cen {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .canvasCircle {
        display: flex;
        width: 45%;
        height: 100%;
        margin-right: 12%;
        align-content: center;
        justify-content: space-between;

        .myprogress {
          width: 100%;
          height: 80px;
          display: flex;
          justify-content: center;

          // .custom-progress {
          //    background-color: red;
          // }
          /deep/.aa {
            bottom: 25% !important;
          }
        }

        .circle {
          // margin-right: 46px;
          // margin-top: 20px;

          .num {
            margin-top: 12px;
            margin-bottom: 2px;
            font-size: 16px;
            font-weight: bold;
          }

          .name {
            font-size: 13px;
          }

          .num,
          .name {
            text-align: center;
            white-space: nowrap;
          }
        }

        .circle:nth-child(3) {
          margin-right: 0;
        }
      }
    }

    .li {
      img {
        width: 30px;
        height: 30px;
        margin-right: 4px;
      }

      display: flex;
      align-items: center;
      font-size: 13px;

      .li_txt {
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  .right {
    width: calc(50% - 6px);
  }
}

.one {
  display: flex;
  width: 100%;
  margin-bottom: 12px;

  .box {
    height: 84px;
    width: calc(33.33% - 8px);
    margin-right: 12px;
    background: url(../../assets/enterprise/tongji3.png) no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    display: flex;
    padding: 8px 0;

    .o_txt {
      border-right: 1px solid #0b3270;
      width: 33.33%;
      box-sizing: border-box;
      padding-left: 20px;

      .t1 {
        font-family: Microsoft YaHei;
        font-size: 14px;
      }

      .t2 {
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        letter-spacing: 0em;
        font-variation-settings: "opsz" auto;
        background: linear-gradient(180deg, #f3f8ff 22%, #4d93ff 82%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }

      .tt1 {
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        letter-spacing: 0em;
        font-variation-settings: "opsz" auto;
        background: linear-gradient(180deg, #fffdf3 24%, #ffde58 80%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }

      .tt2 {
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        letter-spacing: 0em;
        font-variation-settings: "opsz" auto;
        background: linear-gradient(180deg, #fff1e5 22%, #ff963f 78%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }

      .t3 {
        font-size: 12px;
      }
    }

    .o_txt:nth-child(3) {
      border: none;
    }
  }

  .box:nth-child(2) {
    background: url(../../assets/enterprise/tongji2.png) no-repeat;
    background-size: 100% 100%;
  }

  .box:nth-child(3) {
    background: url(../../assets/enterprise/tongji.png) no-repeat;
    margin-right: 0;
    background-size: 100% 100%;
  }
}

#kanban {
  width: 100%;
  position: fixed;
  top: 0;
  margin: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100% !important;
  z-index: 10;
}

.table {
  .tab_li {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #0e294c;
    padding: 8px 0;

    .text {
      flex: 1;
      overflow: hidden;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .time {
      font-size: 13px;
    }
  }
}

.medile {
  flex: 1;
  display: flex;
  align-items: self-end;
  padding: 0 8px;

  .m_left {
    width: 50%;
    height: 227px;
  }

  .m_right {
    width: 50%;
    height: 227px;
  }
}

.con_tent>.medile {
  width: 49%;
}

.con_tent {
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

.kanban {
  width: 100%;
  background: url(../../assets/enterprise/bg.png) no-repeat;
  background-size: 100% 100%;
  color: #fff;

  .tit {
    position: relative;

    .imgs {
      position: absolute;
      right: 20px;
      top: 31px;
    }

    .my-timer {
      position: absolute;
      top: 57px;
      right: 20px;
      display: flex;
      align-items: center;
      font-size: 16px;

      .xingqi {
        margin: 0 20px;
      }
    }

    .txt {
      position: absolute;
      left: 50%;
      top: 12%;
      transform: translateX(-50%);
      font-size: 36px;

      font-family: YouSheBiaoTiHei;

      font-weight: bold;
      line-height: normal;
      text-align: center;
      display: flex;
      align-items: center;
      letter-spacing: 3px;
      font-size: 36px;
      font-variation-settings: "opsz" auto;
      background: linear-gradient(180deg, #f3f8ff 22%, #4d93ff 82%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
  }
}
</style>
<style>
.OverviewAll .el-progress__text {
  display: none;
}

.OverviewAll .el-progress-bar {
  box-sizing: content-box;
}
</style>